export default "__VITE_ASSET__BSOudPbf__"